if (!customElements.get('sticky-cart')) {
  customElements.define('sticky-cart', 
    class StickyCart extends HTMLElement
    {
      constructor() {
        super();
        console.log("1111111111");
        
      }

      connectedCallback() {
          console.log("sticky-cart connected");
            // ✅ 1. 先处理 anchor scroll 逻辑
          this.initAnchorScroll();

          // ✅ 2. 再处理 sticky header
          this.initStickyObserver();

          // ✅ 3. 原有的 scroll/variant/quantity 逻辑...
          this.initOtherEvents();

        this.currentScrollTop = 0;
        this.form = document.getElementById(this.dataset.form);
        this.formButtons = this.form.querySelector('.product-form__buttons');
        this.primaryQuantityInput = this.form.querySelector('.quantity__input');
        this.quantityInput = this.querySelector('.quantity__input');
        if(this.dataset.stickyType == 'on_scroll_up') {
          this.onScrollHandler = this.onScrollType1.bind(this);
        } else {
          this.onScrollHandler = this.onScrollType2.bind(this);
        }
        
        this.variantButtonMobile = this.querySelector('.stick-cart__variant-select-mobile-button');
        if(this.formButtons) {
          window.addEventListener('scroll', this.onScrollHandler, false);
        }

        if(this.primaryQuantityInput) {
          this.onPrimaryQuanityInputChangeHandler = this.onPrimaryQuanityInputChange.bind(this);
          this.primaryQuantityInput.addEventListener('change', this.onPrimaryQuanityInputChangeHandler);
        }

        this.onVariantChangeHandler = this.onVariantChange.bind(this);
        document.addEventListener('afterVariantChanged', this.onVariantChangeHandler);
        if(this.variantButtonMobile) {
          this.onClickVariantButtonMobileHandler = this.onClickVariantButtonMobile.bind(this);
          this.variantButtonMobile.addEventListener('click', this.onClickVariantButtonMobileHandler);
        }

        this.onFocusInHandler = this.onFocusIn.bind(this);
        this.onFocusOutHandler = this.onFocusOut.bind(this);

        this.addEventListener('focusin', this.onFocusInHandler);
        this.addEventListener('focusout', this.onFocusOutHandler);
      }

      disconnectedCallback() {
        if(this.formButtons) {
          window.removeEventListener('scroll', this.onScrollHandler);
        }
        if(this.primaryQuantityInput) {
          this.primaryQuantityInput.removeEventListener('change', this.onPrimaryQuanityInputChangeHandler);
        }
        if(this.variantButtonMobile) {
          this.variantButtonMobile.removeEventListener('click', this.onClickVariantButtonMobileHandler);
        }
        this.removeEventListener('focusin', this.onFocusInHandler);
        this.removeEventListener('focusout', this.onFocusOutHandler);
        document.removeEventListener('afterVariantChanged', this.onVariantChangeHandler);
      }

      open() {
        this.classList.add('open');
        document.body.classList.add('open-sticky-cart');
      }

      hide() {
        this.classList.remove('open');
        document.body.classList.remove('open-sticky-cart');
      }

      onFocusIn() {
        this.classList.add('working');
        this.open();
      }

      onFocusOut() {
        this.classList.remove('working');
        if(this.formButtons.getBoundingClientRect().top >= 0) {
          this.classList.remove('open');
        }
      }

      /**
       * Only visible when scrolling up 
       */
      onScrollType1(event) {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        if(!this.classList.contains('working')) {
          if (scrollTop > this.currentScrollTop) {
            // Scrolling down
            this.hide();
          } else {
            // Scrolling up
            this.toggleBasedOnFormButtons();
          }
        }

        this.currentScrollTop = scrollTop;
      }

      /**
       * Always visible
       */
      onScrollType2(event) {
        this.toggleBasedOnFormButtons();
      }

      toggleBasedOnFormButtons() {
        if(this.formButtons.getBoundingClientRect().top >= 0) {
          this.hide();
        } else {
          this.open();
        }
      }

      onPrimaryQuanityInputChange() {
        this.quantityInput.value = this.primaryQuantityInput.value;
      }

      onVariantChange(event) {
        if(event.detail.sectionId !== this.dataset.section) return;
        // Update variant title on mobile
        if(this.variantButtonMobile) {
          this.variantButtonMobile.querySelector('span').textContent = event.detail.variant.title;
        }
      }

      onClickVariantButtonMobile(event) {
        const target = event.currentTarget;
        const variantPicker = document.getElementById(target.dataset.variantPickerElement);
        if(variantPicker) {
          variantPicker.scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" });
          this.hide();
          this.classList.remove('working');
        }
      }

      initAnchorScroll() {
      const anchorContainer = document.querySelector('.anchor_point_inner');
      if (!anchorContainer) return;

      const anchorLinks = anchorContainer.querySelectorAll('a[href^="#"]');
      if (anchorLinks.length === 0) return;

      const targetToPLink = new Map();

      anchorLinks.forEach(link => {
        const targetId = link.getAttribute('href');
        const targetElement = document.querySelector(targetId);
        const parentP = link.closest('p');
        if (targetElement && parentP) {
          targetToPLink.set(targetElement, parentP);
        }
      });

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach(entry => {
            const pElement = targetToPLink.get(entry.target);
            if (pElement) {
              if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
                document.querySelectorAll('.anchor_point_inner p.active').forEach(el => {
                  el.classList.remove('active');
                });
                pElement.classList.add('active');
              }
            }
          });
        },
        {
          root: null,
          rootMargin: '0px',
          threshold: [0, 0.1, 0.5, 0.9, 1]
        }
      );

      targetToPLink.forEach((_, targetElement) => {
        observer.observe(targetElement);
      });

      anchorLinks.forEach(link => {
        link.addEventListener('click', function(e) {
          const targetId = this.getAttribute('href');
          if (!targetId) return;
          const targetElement = document.querySelector(targetId);
          if (!targetElement) return; // ✅ 这一行非常关键！
          const pElement = targetToPLink.get(targetElement);
          if (!targetElement || !pElement) return;

          e.preventDefault();

          // 移除原 active，再设置当前 active
          document.querySelectorAll('.anchor_point_inner p.active').forEach(el => {
            el.classList.remove('active');
          });
          pElement.classList.add('active');

          observer.disconnect();

          // ✅ 获取 header 的真实高度
          const header = document.querySelector('.header-top'); 
          console.log(header,"header")
          const headerHeight = 120;

          // ✅ 计算目标位置，并考虑 header 高度偏移
          const targetRect = targetElement.getBoundingClientRect();
          const offsetTop = window.pageYOffset + targetRect.top;

          window.scrollTo({
            top: offsetTop - headerHeight,
            behavior: 'smooth'
          });

          setTimeout(() => {
            targetToPLink.forEach((_, target) => {
              observer.observe(target);
            });
          }, 1000);
        });


      });
    }

    initStickyObserver() {
      const stickyHeader = document.querySelector('.header-top');
      const targetElement = this;

      if (!stickyHeader || !targetElement) return;

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              targetElement.classList.remove('active');
            } else {
              targetElement.classList.add('active');
            }
          });
        },
        {
          root: null,
          rootMargin: '0px',
          threshold: 0
        }
      );

      observer.observe(stickyHeader);
    }

    initOtherEvents() {
      // 你原来 connectedCallback 的逻辑放这里
      this.currentScrollTop = 0;
      this.form = document.getElementById(this.dataset.form);
      this.formButtons = this.form?.querySelector('.product-form__buttons');
      this.primaryQuantityInput = this.form?.querySelector('.quantity__input');
      this.quantityInput = this.querySelector('.quantity__input');

      if (this.dataset.stickyType == 'on_scroll_up') {
        this.onScrollHandler = this.onScrollType1.bind(this);
      } else {
        this.onScrollHandler = this.onScrollType2.bind(this);
      }

      this.variantButtonMobile = this.querySelector('.stick-cart__variant-select-mobile-button');
      if (this.formButtons) {
        window.addEventListener('scroll', this.onScrollHandler, false);
      }

      if (this.primaryQuantityInput) {
        this.onPrimaryQuanityInputChangeHandler = this.onPrimaryQuanityInputChange.bind(this);
        this.primaryQuantityInput.addEventListener('change', this.onPrimaryQuanityInputChangeHandler);
      }

      this.onVariantChangeHandler = this.onVariantChange.bind(this);
      document.addEventListener('afterVariantChanged', this.onVariantChangeHandler);

      if (this.variantButtonMobile) {
        this.onClickVariantButtonMobileHandler = this.onClickVariantButtonMobile.bind(this);
        this.variantButtonMobile.addEventListener('click', this.onClickVariantButtonMobileHandler);
      }

      this.onFocusInHandler = this.onFocusIn.bind(this);
      this.onFocusOutHandler = this.onFocusOut.bind(this);

      this.addEventListener('focusin', this.onFocusInHandler);
      this.addEventListener('focusout', this.onFocusOutHandler);
    }

    }
  );
}